import {
	SET_NAVIGATIONS,
	SET_NAVIGATION,
	CLEAR_NAVIGATIONS,
	CLEAR_NAVIGATION,
	ADD_NAVIGATION,
	UPDATE_NAVIGATION,
	REMOVE_NAVIGATION,
} from './actionTypes';

export const navigation = (state = {}, action) => {
	switch (action.type) {
		case SET_NAVIGATION:
			return action.payload;
		case UPDATE_NAVIGATION:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_NAVIGATION:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_NAVIGATIONS:
			return action.payload;
		case ADD_NAVIGATION:
			return [...state, action.payload];
		case UPDATE_NAVIGATION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_NAVIGATION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_NAVIGATIONS:
			return [];
		default:
			return state;
	}
};
